import React from "react";
import { Button, Icon } from "@axum/ax-design";
import { GridEmpty } from "./OrdersGrid";
import { dayLabel, Elsewhere, rangeLabel, spanOf, useElsewhere } from "../../../utils/elsewhere";
import { useShowRange } from "../../../config/showRange";
import { useOrdersFailed } from "../../../utils/loadErrors";

const describe = (found: Elsewhere) => {
  const newest = found.days[0];
  const oldest = found.days[found.days.length - 1];
  if (!found.complete) {
    return `Hay ${found.total} en los últimos 6 meses; los más recientes, entre el ${dayLabel(oldest.date)} y el ${dayLabel(newest.date)}.`;
  }
  if (found.days.length === 1) return `Hay ${found.total} del ${dayLabel(newest.date)}.`;
  if (found.days.length === 2) {
    return `Hay ${found.total}: ${newest.count} del ${dayLabel(newest.date)} y ${oldest.count} del ${dayLabel(oldest.date)}.`;
  }
  return `Hay ${found.total} entre el ${dayLabel(oldest.date)} y el ${dayLabel(newest.date)}.`;
};

export const useElsewhereEmpty = (entity: string, title: string, filter: any, listEmpty: boolean): GridEmpty => {
  const failed = useOrdersFailed();
  const showRange = useShowRange();
  const found = useElsewhere(entity, filter, listEmpty && !failed);

  if (!found) return { title, description: "Probá con otro rango de fechas o con menos filtros." };
  const range = spanOf(found);
  return {
    title,
    description: describe(found),
    action: (
      <Button size="sm" variant="soft-primary" onClick={() => showRange(range)}>
        <Icon name="calendar" />{rangeLabel(range)}
      </Button>
    ),
  };
};
